/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Col_IndexInputs */

const vi_sinp_col_index = /** @type {(inputs: Sinp_Col_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`STT`)
};

/**

* @param {Sinp_Col_IndexInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_col_index = /** @type {((inputs?: Sinp_Col_IndexInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Col_IndexInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_col_index(inputs)
});